module.exports = "<h1 mat-dialog-title *ngIf=\"data?.title\">{{ data.title | translate }}</h1>\n<div mat-dialog-content *ngIf=\"data?.body\">{{ data.body | translate: data.translateParams }}</div>\n\n<div mat-dialog-actions>\n  <button mat-raised-button color=\"warn\" mat-dialog-close>{{ 'CONFIRMATION_DIALOG.CANCEL' | translate }}</button>\n  <button mat-raised-button (click)=\"confirm()\">\n    {{ 'CONFIRMATION_DIALOG.CONFIRM' | translate }}\n  </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/confirmation-dialog/confirmation-dialog.component.html
// module id = ./src/app/shared/components/confirmation-dialog/confirmation-dialog.component.html
// module chunks = main